import apiClient from '@/services/axios'

export async function put(venueSetupId, floorplan) {
  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/floorplan/' + venueSetupId, floorplan);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to put floorplan.')
}
